import React from 'react';
import { FieldArrayRenderProps, FormikProps } from 'formik';
import { Button } from 'antd';
import cx from 'classnames';

import { CustomerInfoFormValues } from '../CustomerInfo';
import BillingContactsSection, {
  BillingContactFormValues,
} from '../BillingContactSection';
import {
  isAddButtonVisible,
  isRemoveButtonVisible,
} from 'utils/fieldArrayUtils';
import { BillingContactModel } from 'api/backofficeApiClient';

import styles from '.././TimesheetApproverFieldArray/TimeSheetApproverFieldArray.module.less';

type Props = {
  billingContacts?: BillingContactModel[];
};

export default function BillingContactFieldArray(
  props: FieldArrayRenderProps & Props,
) {
  const { billingContacts = [] } = props;
  const { generalInfo } = (props.form as FormikProps<CustomerInfoFormValues>)
    .values;
  const newBillingContacts = generalInfo.newBillingContacts;
  const MAX_BILLING_CONTACTS_LENGTH = 5 - billingContacts.length;

  return (
    <>
      {newBillingContacts.length > 0 &&
        newBillingContacts.map((billingContact, index: number) => (
          <BillingContactsSection
            key={index}
            index={index}
            formik={props.form}
            formNamePrefix={props.name}
            actionButtons={
              <div className={styles.actionButtons}>
                {isAddButtonVisible<BillingContactFormValues>(
                  newBillingContacts,
                  index,
                  MAX_BILLING_CONTACTS_LENGTH,
                ) && (
                  <Button
                    className={cx('borderless-btn', styles.btn)}
                    onClick={() =>
                      props.push({
                        firstName: '',
                        lastName: '',
                        email: '',
                        phoneNumber: '',
                      })
                    }
                    icon={<span className="icon icon-plus-filled" />}
                  />
                )}

                {isRemoveButtonVisible<BillingContactFormValues>(
                  newBillingContacts,
                ) && (
                  <Button
                    className={cx('borderless-btn', styles.btn)}
                    onClick={() => props.remove(index)}
                    icon={<span className="icon icon-closed-filled" />}
                  />
                )}
              </div>
            }
          />
        ))}
    </>
  );
}
